// material-ui
import { Link, Container, Box ,Button, Typography} from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import github from 'assets/images/index/github-fill.svg';

// ==============================|| FOOTER - AUTHENTICATION 2 & 3 ||============================== //

const Footer = () => {
  const siteInfo = useSelector((state) => state.siteInfo);

  return (
    <Container maxWidth={false} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '144px',backgroundColor:'#e4e4e4',width:'100%' }}>
      
      <Typography 
        variant="h1" 
        sx={{ 
          fontSize: '1rem',
          color: 'text.secondary',
        }}
      >
        <a href="https://github.com/MoJIeAIGC/comfyui-MJAPI-party" target="_blank" rel="noopener noreferrer">
        <Button sx={{ 
          '&:hover img': {
            transform: 'scale(1.05) translateY(-0.5px)',
            filter: 'drop-shadow(0 3px 5px rgba(0,0,0,0.1))',
            opacity: 0.9
          }
        }}>
          <img 
            src={github} 
            alt="comfy" 
            style={{ 
              width: 'auto', 
              height: '30px',
              transition: 'all 0.6s cubic-bezier(0.25, 0.8, 0.25, 1)'
            }} 
          />
        </Button>
      </a>
        联系我们: Wechat: MojieAlGC<br/>
        Copyright @ 2025 WeClone. All rights reserved.
      </Typography>
    </Container>
  );
};

export default Footer;
